import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1px solid #D1D5DB',
    borderRadius: 8, fontSize: 14, fontFamily: 'var(--font-body)',
    color: '#0A1628', outline: 'none', boxSizing: 'border-box',
    transition: 'border-color 0.15s', background: 'white',
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'white',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '20px', fontFamily: 'var(--font-body)',
    }}>

      {/* Logo above card */}
      <div style={{ marginBottom: 28, textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center' }}>
          <svg width="28" height="33" viewBox="-1 -1 34 40" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 1 L31 6 L31 21 Q31 33 16 37 Q1 33 1 21 L1 6 Z" fill="white" stroke="#0A1628" strokeWidth="2"/>
            <path d="M6 13 Q11 9 16 12 Q21 15 26 11" stroke="#0A1628" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
            <path d="M6 18 Q11 14 16 17 Q21 20 26 16" stroke="#0066FF" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
            <path d="M6 23 Q11 19 16 22 Q21 25 26 21" stroke="#0066FF" strokeWidth="1.4" fill="none" strokeLinecap="round" opacity="0.6"/>
            <path d="M7 28 Q11 24 16 27 Q21 30 25 26" stroke="#0066FF" strokeWidth="1.1" fill="none" strokeLinecap="round" opacity="0.3"/>
          </svg>
          <div style={{ fontFamily: 'var(--font-heading)', fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px' }}>
            <span style={{ color: '#0066FF' }}>Air</span><span style={{ color: '#0A1628' }}>Comply</span>
          </div>
        </div>
      </div>

      {/* Card */}
      <div style={{
        width: '100%', maxWidth: 400, background: 'white',
        border: '1px solid #E2E8F0', borderRadius: 16, padding: '36px 32px',
      }}>
        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>📧</div>
            <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 20, fontWeight: 700, color: '#0A1628', margin: '0 0 10px' }}>Check your email</h2>
            <p style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.6, marginBottom: 24, fontFamily: 'var(--font-body)' }}>
              If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
            </p>
            <Link to="/login" style={{ color: '#0066FF', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>← Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 20, fontWeight: 700, color: '#0A1628', margin: '0 0 6px', textAlign: 'center' }}>
              Reset your password
            </h1>
            <p style={{ fontSize: 13, color: '#6B7280', textAlign: 'center', marginBottom: 24, fontFamily: 'var(--font-body)' }}>
              Enter your email and we'll send you a reset link.
            </p>

            {error && (
              <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#DC2626' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Email</label>
                <input type="email" required value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  style={inputStyle}
                  onFocus={e => e.target.style.borderColor = '#0066FF'}
                  onBlur={e => e.target.style.borderColor = '#D1D5DB'}
                />
              </div>
              <button type="submit" disabled={loading} style={{
                width: '100%', padding: '11px',
                background: loading ? '#94a3b8' : '#0066FF',
                color: 'white', border: 'none', borderRadius: 8,
                fontSize: 14, fontWeight: 600, fontFamily: 'var(--font-body)',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.15s', marginBottom: 16,
              }}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ fontSize: 13, color: '#6B7280', textDecoration: 'none' }}>← Back to sign in</Link>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <div style={{
        position: 'fixed', bottom: 20, left: 0, right: 0,
        display: 'flex', justifyContent: 'center', gap: 20,
        fontSize: 12, color: '#9CA3AF',
      }}>
        <a href="https://aircomply.com/terms.html" target="_blank" rel="noopener noreferrer"
          style={{ color: '#9CA3AF', textDecoration: 'none' }}>Terms of Service</a>
        <span>·</span>
        <a href="https://aircomply.com/privacy.html" target="_blank" rel="noopener noreferrer"
          style={{ color: '#9CA3AF', textDecoration: 'none' }}>Privacy Policy</a>
      </div>
    </div>
  );
}

export default ForgotPassword;
